import { ALL_DASHBOARD_BILLING_CHART_FAIL, ALL_DASHBOARD_BILLING_CHART_REQUEST, ALL_DASHBOARD_BILLING_CHART_SUCCESS, ALL_DASHBOARD_CHART_FAIL, ALL_DASHBOARD_CHART_REQUEST, ALL_DASHBOARD_CHART_SUCCESS, ALL_DASHBOARD_LINE_CHART_FAIL, ALL_DASHBOARD_LINE_CHART_REQUEST, ALL_DASHBOARD_LINE_CHART_SUCCESS, CARRIER_METRICS_REQUEST, CARRIER_METRICS_SUCCESS, CARRIER_METRICS_FAIL, TOP_CARRIERS_WIDGET_REQUEST, TOP_CARRIERS_WIDGET_SUCCESS, TOP_CARRIERS_WIDGET_FAIL } from "../constants/adminPortal_dashboardConstants"

export const allDashboardChartReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case ALL_DASHBOARD_CHART_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case ALL_DASHBOARD_CHART_SUCCESS:

            return {
                ...state,
                loading: false,
                managereport: action.payload
            }
        case ALL_DASHBOARD_CHART_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}

export const allDashboardBillingChartReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case ALL_DASHBOARD_BILLING_CHART_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case ALL_DASHBOARD_BILLING_CHART_SUCCESS:

            return {
                ...state,
                loading: false,
                billingchart: action.payload
            }
        case ALL_DASHBOARD_BILLING_CHART_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}
export const allDashboardLineChartReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case ALL_DASHBOARD_LINE_CHART_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case ALL_DASHBOARD_LINE_CHART_SUCCESS:

            return {
                ...state,
                loading: false,
                linechart: action.payload
            }
        case ALL_DASHBOARD_LINE_CHART_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}

export const carrierMetricsReducer = (state = { loading: false, data: null, error: null }, action) => {
    switch (action.type) {
        case CARRIER_METRICS_REQUEST:
            return { ...state, loading: true, error: null }
        case CARRIER_METRICS_SUCCESS:
            return { ...state, loading: false, data: action.payload }
        case CARRIER_METRICS_FAIL:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

// State is keyed by source ("did_carrier" | "termination" | "caller_network")
// so the tabbed Top 4 Carriers widget can cache each tab independently and
// avoid refetching when the user toggles between tabs.
const _topCarrierInitial = {
    loading: { did_carrier: false, termination: false, caller_network: false },
    data: { did_carrier: null, termination: null, caller_network: null },
    error: { did_carrier: null, termination: null, caller_network: null },
}

export const topCarriersWidgetReducer = (state = _topCarrierInitial, action) => {
    const src = action.source
    switch (action.type) {
        case TOP_CARRIERS_WIDGET_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, [src]: true },
                error: { ...state.error, [src]: null },
            }
        case TOP_CARRIERS_WIDGET_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, [src]: false },
                data: { ...state.data, [src]: action.payload },
            }
        case TOP_CARRIERS_WIDGET_FAIL:
            return {
                ...state,
                loading: { ...state.loading, [src]: false },
                error: { ...state.error, [src]: action.payload },
            }
        default:
            return state
    }
}